<template>
  <v-btn icon rounded="xl" variant="flat" v-on:click="drawer = !drawer" :color="drawer ? '#C8E6C9' : 'grey'">
    <v-icon :icon="['fas', drawer ? 'folder-open' : 'folder']" />
  </v-btn>

  <v-navigation-drawer v-model="drawer" width="500" temporary color="grey-lighten-3" location="end">
    <v-card flat rounded="0" color="transparent">
      <template v-slot:title>
        ОТЧЁТЫ
      </template>
      <template v-slot:subtitle>
        В БРАУЗЕРЕ
      </template>
      <template v-slot:append>
        <v-sheet class="d-flex justify-center align-center flex-column" color="transparent">
          <v-btn icon flat color="red" variant="outlined" v-on:click="drawer = false" size="small">
            <v-icon :icon="['fas', 'xmark']" />
          </v-btn>
        </v-sheet>

      </template>
    </v-card>
    <template v-for="(report, index) in list" :key="report">
      <BrowserSaver__Card :report="report" :index="index" />
    </template>
  </v-navigation-drawer>
</template>

<script>
import { Allerts } from "@/store/global/Allerts";
import { Rep_Contract, Rep_Contracts, Rep_Period } from "@/store/report/SmallStorrage";
import { ReportData } from "@/store/report/ReportData";
import { ItemData, ItemDesc, ItemName, ItemUUID, ListOfReports } from "@/store/report/save.store";
import {TokenGUIDStore} from "@/store/global/SessionStore";
import BrowserSaver__Card from "@/components/Reports/BrowserSaver__Card.vue";


export default {
  name: "BrowserSaver",
  components: {BrowserSaver__Card},
  data() {
    return {
      drawer: false,
    }
  },
  async beforeMount() {
    await this.get_reports_list()
  },
  methods: {
    selectLocalFile: function (report) {
      this.item_data = report
      this.item_name = report.name
      this.item_desc = report.description
      this.item_uuid = report.uuid

      this.report_data = JSON.parse(report.line)
      this.range = report.range
      this.contract = report.contract
      this.$router.push({ name: 'report__editor'})
      Allerts().warn('ЗАГРУЖЕНО', `Файл успешно подгружен!`,'light-green', 'floppy-disk')
    },
    get_reports_list: async function () {
      let url = `${this.$config.SSL}://${this.$config.ONEADDRESS}/${this.$config.BASE}/${this.$config.API_VERSION}/rm/reports`

      let properies = {
        method: 'GET',
        withCredentials: true,
        headers: {
          "Authorization": "Bearer " + this.session_token
        }
      }
      await fetch(url, properies)
          .then(async response => {
            if (response.ok) {
              return await response.json()
            } else {
              throw `Ошибка получения Документов!`
            }
          })
          .then(result => {
            this.list = result
          }).catch(err => {
            Allerts().warn('ОШИБКА', err, '#ff0000', 'triangle-exclamation')
            console.error(err)
          })
    }
  },
  computed: {
    contracts: {
      get() {
        return Rep_Contracts().get()
      },
      set(value) {
        Rep_Contracts().set(value)
      }
    },
    range: {
      get() {
        return Rep_Period().get()
      },
      set(value) {
        Rep_Period().set(value)
      }
    },
    contract: {
      get() {
        return Rep_Contract().get()
      },
      set(value) {
        Rep_Contract().set(value)
      }
    },
    report_data: {
      get() {
        return ReportData().get()
      },
      set(value) {
        ReportData().set(value)
      }
    },
    item_uuid: {
      get() {
        return ItemUUID().get()
      },
      set(value) {
        ItemUUID().set(value)
      }
    },
    item_name: {
      get() {
        return ItemName().get()
      },
      set(value) {
        ItemName().set(value)
      }
    },
    item_desc: {
      get() {
        return ItemDesc().get()
      },
      set(value) {
        ItemDesc().set(value)
      }
    },
    item_data: {
      get() {
        return ItemData().get()
      },
      set(value) {
        ItemData().set(value)
      }
    },
    list: {
      get() {
        return ListOfReports().get()
      },
      set(value) {
        ListOfReports().set(value)
      }
    },
    session_token() {
      return TokenGUIDStore().get()
    }
  }
}
</script>

<style scoped>
#selectus {
  background: transparent !important;
  background: linear-gradient(90deg, rgba(0,0,0,0) 0%, rgba(255,255,255,1) 50%, rgba(255,255,255,1) 100%) !important;
  padding-left: 10px;
  margin-left: -10px;
  border-radius: 0 10px 10px 0;
}
.drop-area {
  margin: 10px;
  border-radius: 5px;
  border: 2px dashed #dadada;
}
.hovered {
  border: 2px dashed #ffb700;
}

.drop {
  border: 2px solid #ffb700;
}
</style>
